import type { OngoingDownload } from '@mimir/client-common/model/ongoingDownload';
import { completeAndImport } from './completeAndImport';
import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';
import type { NotificationOps } from '@mimir/client-common/fileSync/notificationOps';
import type { Logger } from '@mimir/common/types/logger';
import { tryGetLocallyAvailableFile } from '@mimir/client-common/fileSync/downloadDestinationUtils';
import type { LocalStateOps } from '@mimir/client-common/fileSync/localStateOps';


export async function tryImport(
  services: {
    applicationContext: AdobePanelContext | ElectronContext,
    notificationOps: NotificationOps,
    logger: Logger,
    localStateOps: LocalStateOps,
  },
  config: {
    downloadPath: string,
    userDataSystemPath: string,
    shouldUsePremierePreferences: boolean,
  },
  ongoingDownload: OngoingDownload,
  localPathToCheck: string | undefined,
) {

  const locallyAvailablePath = await tryGetLocallyAvailableFile(services, ongoingDownload, localPathToCheck);
  if (locallyAvailablePath !== undefined) {
    return completeAndImport(services, config, ongoingDownload, locallyAvailablePath);
  }

  return false;
}
